import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useDelete from "./hooks/useDelete";
import useUpdate from "./hooks/useUpdate";
import { GenericMethods } from "../GenericMethods";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { useState } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import Button from "@mui/material/Button";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import { canViewEvent, eventViewButtonSx, getEventViewUrl } from "./eventView";

function Update() {
  const id = Number(useParams()?.id);
  const [state, setState] = useState<JsonFormsStateProps<SchemaData>>();
  const eventStatus = state?.data?.status;
  const eventSlug = state?.data?.slug;
  const eventPublishOn = state?.data?.publishOn;
  const viewDisabled = !canViewEvent(eventStatus, eventSlug);
  const viewHref = viewDisabled
    ? undefined
    : getEventViewUrl(eventStatus, eventSlug, eventPublishOn);

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath={`${Sites.UNIFTEC.path}/eventos`}
      useDelete={useDelete}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
      state={state}
      setState={setState}
    >
      <Button
        variant="outlined"
        color="info"
        startIcon={<LaunchRoundedIcon />}
        href={viewHref}
        target="_blank"
        rel="noreferrer"
        disabled={viewDisabled}
        sx={eventViewButtonSx}
      >
        Ver
      </Button>
    </GenericMethods.Update>
  );
}

export default Update;
